import { htPdfDrawFullWidthBlockFrame } from './htPdfFullWidthFrame';

const PAD = 1.2;
const EXCEL_PT_TO_MM = 25.4 / 72;
/** Filas 33–35: un solo bloque (sin líneas horizontales internas en plantilla). */
const MOD_PAD_TOP = 1.8;
const MOD_PAD_BOTTOM = 1.6;
const MOD_GAP_TITLE_OPTS = 0.65;
const MOD_GAP_OPTS_SUB = 0.45;
const MOD_LH_TITLE = 3.1;
const MOD_LH_OPTS = 2.85;
const MOD_LH_SUB = 2.55;

const H_MOD_BLOCK =
  MOD_PAD_TOP +
  MOD_LH_TITLE +
  MOD_GAP_TITLE_OPTS +
  MOD_LH_OPTS +
  MOD_GAP_OPTS_SUB +
  MOD_LH_SUB +
  MOD_PAD_BOTTOM;

/** Filas 33–35: modalidad de tratamiento (lote/ciclo en drawHtTreatmentBlockPdf fila 36). */
export function drawHtModalitySectionPdf(doc, S, xs, y) {
  const x0 = xs[0];
  const xEnd = xs[5];
  const wFull = xEnd - x0;
  const maxW = wFull - PAD * 2;
  const cx = x0 + wFull / 2;

  htPdfDrawFullWidthBlockFrame(doc, xs, y, H_MOD_BLOCK, 33, 35);

  let cy = y + MOD_PAD_TOP;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7);
  doc.text(S.HT_MODALITY_TITLE, cx, cy, { align: 'center', baseline: 'top', maxWidth: maxW });
  cy += MOD_LH_TITLE + MOD_GAP_TITLE_OPTS;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(6.2);
  doc.text(S.HT_MODALITY_LINE, cx, cy, { align: 'center', baseline: 'top', maxWidth: maxW });
  cy += MOD_LH_OPTS + MOD_GAP_OPTS_SUB;

  doc.setFont('helvetica', 'italic');
  doc.text(S.HT_MODALITY_SUB, cx, cy, { align: 'center', baseline: 'top', maxWidth: maxW });
  doc.setFont('helvetica', 'normal');

  y += H_MOD_BLOCK;

  return y;
}
